import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import _extends from "@babel/runtime/helpers/extends";
var _excluded = ["navigationPriority", "groupName"],
    _excluded2 = ["props"];
import _isArray from 'lodash/isArray';
import _sortBy from 'lodash/sortBy';
import _values from 'lodash/values';

function getIndividualLinks(links) {
  return links.filter(function (_ref) {
    var groupName = _ref.groupName;
    return !groupName;
  });
}

function createLinkGroups(links) {
  return links.reduce(function (linkGroups, link) {
    var groupName = link.groupName;

    if (groupName) {
      var _extends2;

      return _extends({}, linkGroups, (_extends2 = {}, _extends2[groupName] = linkGroups[groupName] ? [].concat(linkGroups[groupName], [link]) : [link], _extends2));
    }

    return linkGroups;
  }, {});
}

function linksToGroupOfLinks(individualLinks, groupedLinks) {
  return [].concat(individualLinks, _values(groupedLinks)).map(function (linkOrGroup) {
    if (_isArray(linkOrGroup)) {
      var firstGroupItem = linkOrGroup[0];
      var groupName = firstGroupItem.groupName,
          navigationPriority = firstGroupItem.navigationPriority;
      return {
        navigationPriority: navigationPriority,
        title: groupName,
        links: linkOrGroup
      };
    }

    return linkOrGroup;
  });
}

export function sortLinks(links) {
  // Sorts by navigationPriority and remove that property
  return _sortBy(links, ['navigationPriority']);
}
export function cleanLinkProps(links) {
  return links.map(function (_ref2) {
    var navigationPriority = _ref2.navigationPriority,
        groupName = _ref2.groupName,
        link = _objectWithoutPropertiesLoose(_ref2, _excluded);

    return link;
  });
}
export function transformLinks(links) {
  return links.map(function (link) {
    var props = link.props,
        rest = _objectWithoutPropertiesLoose(link, _excluded2);

    if (props) {
      return _extends({}, JSON.parse(props), rest);
    }

    return rest;
  });
}
export function groupLinks(links) {
  var transformedLinks = transformLinks(links);
  var individualLinks = getIndividualLinks(transformedLinks);
  var linkGroups = createLinkGroups(transformedLinks);
  var mergedLinks = linksToGroupOfLinks(individualLinks, linkGroups);
  var sortedLinks = sortLinks(mergedLinks);
  var cleanedLinks = cleanLinkProps(sortedLinks);
  return cleanedLinks;
}